export const NAME = 'messaging'
